<!--电子围栏列表-->
<template>
  <div>
    <div style="margin-bottom: 16px">
      <div style="display: flex; align-items: center">
        <span
          style="flex: 1; font-size: 12px; font-weight: bold; color: #0f1a3a"
          >{{ $t("arealimitset.electronicFencelist") }}</span
        >
        <div>
          <kl-label
            @click="onAddClick"
            :title="$t('public.add')"
            icon="icon-icon_operat_increa"
            :iconSize="16"
            :fontSize="12"
            style="margin-right: 12px; cursor: pointer"
          />
          <kl-label
            @click="onEditClick"
            :title="$t('public.edit')"
            icon="icon-icon_buslist_xxfb"
            :iconSize="16"
            :fontSize="12"
            style="margin-right: 12px; cursor: pointer"
          />
          <kl-label
            @click="onSetVehicleClick"
            :title="$t('public.SetVehicles')"
            icon="icon-icon_operat_bus"
            :iconSize="16"
            :fontSize="12"
            style="margin-right: 12px; cursor: pointer"
          />
          <kl-label
            @click="onDelClick"
            :title="$t('public.del')"
            icon="icon-icon_operat_delete"
            :iconSize="16"
            :fontSize="12"
            style="cursor: pointer"
          />
        </div>
      </div>
    </div>
    <div style="width: 100%">
      <!--搜索-->
      <el-form
        @submit.native.prevent
        :size="size"
        :model="form"
        label-width="0"
      >
        <el-form-item label="">
          <el-input
            prefix-icon="el-icon-search"
            v-model="form.AreaName"
            clearable
            :placeholder="$t('arealimitset.plsareaname')"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="queryList"
            ></el-button
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div style="height: calc(100vh - 330px); overflow: auto">
        <el-table
          v-loading="loading"
          size="mini"
          :data="tableData"
          border
          highlight-current-row
          style="width: 100%"
          @row-click="tableClickRow"
          @row-dblclick="tableDbClickRow"
          @current-change="handleCurrentChange"
        >
          <el-table-column
            prop="AreaName"
            align="center"
            :label="$t('arealimitset.fencename')"
          >
          </el-table-column>
          <el-table-column
            prop="AreaType"
            align="center"
            width="60"
            :label="$t('areatype.title')"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.AreaType == 1">{{
                $t("areatype.rectangle")
              }}</span>
              <span v-if="scope.row.AreaType == 0">{{
                $t("areatype.circular")
              }}</span>
              <span v-if="scope.row.AreaType == 2">{{
                $t("areatype.polygon")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="MaxSpeed"
            align="center"
            width="95"
            :label="$t('arealimitset.maxSpeed') + '(km/h)'"
          >
          </el-table-column>
          <el-table-column
            prop="VelCount"
            align="center"
            :label="$t('arealimitset.bindvehiclecount')"
            width="85"
          >
            <template slot-scope="scope">
              <span
                style="color: #2a7aff; cursor: pointer"
                @click="onSetSingleAreaVehicleClick(scope.row)"
                >{{ scope.row.VelCount }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="AreaAttribute"
            align="center"
            width="60"
            :label="$t('arealimitset.alarmtype')"
          >
            <template slot-scope="scope">
              <span>{{ getAreaAttributeRemark(scope.row.AreaAttribute) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <kl-pagination
        :total="total"
        @current-change="pageChange"
        :current-page.sync="form.PageNo"
      >
      </kl-pagination>
    </div>
    <limit_area_remind_set_info ref="model" @ok="submitOk" />
    <limit_area_remind_set_vehicle ref="vmodel" />
  </div>
</template>
<script>
import limit_area_remind_set_info from "./limit_area_remind_set_info";
import limit_area_remind_set_vehicle from "./limit_area_remind_set_vehicle";
export default {
  props: {
    map: {
      type: Object,
      default: undefined,
    },
  },
  components: { limit_area_remind_set_info, limit_area_remind_set_vehicle },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },
  },
  data() {
    return {
      form: {
        OperatorID: 0,
        AreaName: "",
        PageNo: 1,
        QueryFlag: 0,
        PageSize: 10,
      },

      tableData: [],
      loading: false,
      total: 0,
      currentRow: undefined,
    };
  },
  methods: {
    getAreaAttributeRemark(areaAttribute) {
      var result = "";
      if (areaAttribute & 0x01) result += this.$t("time.activationTime") + ",";

      if (areaAttribute & 0x02)
        result += this.$t("arealimitset.limitspeed") + ",";

      if (areaAttribute & 0x04)
        result += this.$t("arealimitset.enterAreaAlarmToDriver") + ",";

      if (areaAttribute & 0x08)
        result += this.$t("arealimitset.enterAreaAlarmToCenter") + ",";

      if (areaAttribute & 0x10)
        result += this.$t("arealimitset.outAreaAlarmToDriver") + ",";

      if (areaAttribute & 0x20)
        result += this.$t("arealimitset.outAreaAlarmToCenter") + ",";

      if (result != "") result = result.substr(0, result.length - 1);

      return result;
    },
    submitOk() {
      this.queryList();
    },
    tableDbClickRow(row) {
      this.$refs.model.edit(row);
    },
    tableClickRow(row) {
      console.log(row);
      console.log(this.map);
      if (!this.map) return;
      this.map.clearAll();

      if (row && (row.Lonlats || row.AddedInfo)) {
        switch (row.AreaType) {
          case 0:
            var circleInfo = row.AddedInfo.split(",");
            if (circleInfo.length == 3) {
              this.map.addCircle(
                row.AreaID,
                { lng: circleInfo[1], lat: circleInfo[2] },
                circleInfo[0]
              );
              this.map.setCenter(circleInfo[1], circleInfo[2]);
            }

            break;
          case 1: //矩形
            //todo  缩放到适当的区域
            var circleInfo = row.Lonlats.split(";");

            var ne = circleInfo[0].split(",");
            var sw = circleInfo[1].split(",");

            var lon = (parseFloat(ne[1]) + parseFloat(sw[1])) / 2;
            var lat = (parseFloat(ne[2]) + parseFloat(sw[2])) / 2;

            this.map.setCenter(lon, lat);

            var coordanites = [];
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(ne[2]),
            });
            coordanites.push({
              lng: parseFloat(ne[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(sw[2]),
            });
            coordanites.push({
              lng: parseFloat(sw[1]),
              lat: parseFloat(ne[2]),
            });

            this.map.addPolygon(
              "AREA1",
              row.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );

            break;
          case 2: //多边形
            //todo  缩放到适当的区域
            var circleInfo = row.Lonlats.split(";");

            var center = circleInfo[0].split(",");

            this.map.setCenter(parseFloat(center[1]), parseFloat(center[2]));

            var coordanites = [];
            circleInfo.forEach((element) => {
              var p = element.split(",");
              coordanites.push({
                lng: parseFloat(p[1]),
                lat: parseFloat(p[2]),
              });
            });

            this.map.addPolygon(
              "AREA1",
              row.AreaName,
              coordanites,
              3,
              0xcd3700,
              0xb3ee3a
            );

            break;
        }
      }
    },
    onSetSingleAreaVehicleClick(row) {
      //弹出车辆选择框
      this.$refs.vmodel.bind(row, 1);
    },
    onSetVehicleClick() {
      if (!this.currentRow || this.currentRow == {}) {
        this.$message.warning(this.$t("arealimitset.plsselectarea"));
        return;
      }

      //弹出车辆选择框
      this.$refs.vmodel.bind(this.currentRow, 2);
    },
    onDelClick() {
      if (!this.currentRow || this.currentRow == {}) {
        this.$message.warning(this.$t("arealimitset.plsselectarea"));
        return;
      }
      this.$confirm(
        this.$t("arealimitset.confirmdelarea"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.$api
          .removeSpeedLimitArea({
            AreaID: this.currentRow.AreaID,
            OperatorID: this.operator.OperatorId,
          })
          .then((res) => {
            this.$message.success(this.$t("public.hasDeleted"));
            // this.form.PageNo = 1;
            this.queryList();
          })
          .catch(() => {
            this.$message.error(this.$t("public.DeleteFail"));
          });
      });
      //删除区域
    },
    handleCurrentChange(row) {
      if (row == null) return;
      this.currentRow = row;
    },

    onEditClick() {
      if (!this.currentRow || this.currentRow == {}) {
        this.$message.warning(this.$t("arealimitset.plsselectarea"));
        return;
      }
      //获取选中的数据
      this.$refs.model.edit(this.currentRow);
    },
    onAddClick() {
      this.$refs.model.add();
    },
    pageChange(page) {
      this.form.PageNo = page;
      this.queryList();
    },
    queryList() {
      this.loading = true;

      this.form.OperatorID = this.operator.OperatorId;
      this.$api
        .querySpeedLimitArea(this.form)
        .then((res) => {
          this.loading = false;
          this.total = res.count;
          this.tableData = res.data;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.queryList();
  },
};
</script>
